import React, { useState } from 'react';
import { Content, Pane, Flex } from '@leverege/ui-elements';
import { R } from '@leverege/value-resolver';
import { useValueChange } from '@leverege/ui-hooks';
import { Card } from "../model/index.js";
import { CardTitle, ToolbarContext, VariantCreator } from "../shared/index.js";
import { useDashboardContext } from "../shared/DashboardContext.js";
export default function CardView(props) {
  const {
    value
  } = props;
  const dashboardContext = useDashboardContext();
  const {
    viewers,
    columns: maxColumns,
    sharedProps
  } = dashboardContext;
  const vc = new VariantCreator('Card', value.style);
  const onModelChange = useValueChange(Card, props);
  const [toolbarRef, setToolbarRef] = useState(null);
  const style = {
    gridColumnEnd: `span ${Math.min(maxColumns, value.width || 1)}`,
    gridRowEnd: `span ${value.height || 1}`
  };
  const content = viewers.create(value.content, {
    value: value.content,
    sharedProps,
    onChange: onModelChange,
    eventData: 'setContent'
  });
  const plugin = viewers.get(value.content);
  if (!plugin) {
    return null;
  }
  let typeName = plugin ? plugin.getCardTitle || plugin.name || plugin.NAME || plugin.TYPE : null;
  let typeIcon = plugin ? plugin.getCardIcon || plugin.icon || plugin.ICON : null;
  typeName = R(typeName, value.content, dashboardContext);
  typeIcon = R(typeIcon, value.content, dashboardContext);
  return /*#__PURE__*/React.createElement(Pane, {
    variant: vc.get(),
    style: style
  }, /*#__PURE__*/React.createElement(Content, {
    relative: true
  }, /*#__PURE__*/React.createElement(Content.Header, {
    variant: vc.get('Header')
  }, /*#__PURE__*/React.createElement(CardTitle, {
    title: Card.getTitle(value),
    icon: Card.getIcon(value),
    typeIcon: typeIcon,
    typeName: typeName,
    titleVisible: Card.isTitleVisible(value),
    variant: vc.get('Title')
  }, /*#__PURE__*/React.createElement(Flex, {
    justify: "space-between",
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    ref: ref => setToolbarRef(ref)
  })))), /*#__PURE__*/React.createElement(Content.Area, {
    variant: vc.get('Area')
  }, /*#__PURE__*/React.createElement(ToolbarContext.Provider, {
    value: toolbarRef
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    align: "stretch"
  }, content)))));
}